const tblSingle = {
  55: [8.0,21.00, 20.70],
  56: [9.0,22.00,21.06],
  57: [10.0, 23.00, 21.09],
  58: [11.5, 24.00, 22.86],
  59: [12.5, 25.00, 24.60],
  60: [14.0, 26.00, 23.81],
  61: [15.0, 27.00, 26.40],
  62: [16.0, 28.00, 24.20],
  63: [17.0, 29.00, 23.95],
  64: [18.0, 30.00, 24.89],
  65: [19.5, 31.00, 24.05],
  66: [21.0, 32.00, 25.35],
  67: [22.0, 33.00, 26.65],
  68: [23.0, 34.00, 25.97],
  69: [24.5, 35.00, 28.04],
  70: [26.0, 36.00, 25.43],
  71: [27.0, 37.00, 25.44],
  72: [28.0, 38.00, 23.81],
  73: [28.5, 39.00, 25.59],
  74: [29.0, 40.00, 26.76],
  75: [30.0, 41.00, 25.92],
  76: [30.5, 42.00, 26.81],
  77: [31.0, 43.00, 29.68],
  78: [32.0, 44.00, 25.11],
  79: [33.0, 45.00, 28.53],
  80: [34.0, 46.00, 23.60],
  81: [35.0, 47.00, 25.15],
  82: [36.0, 48.00, 23.48],
  83: [37.0, 49.00, 25.28],
  84: [38.0, 50.00, 27.69]
};

const tblJoint = {
  55: [8.0,19.50, 20.70],
  56: [9.0,20.50,21.06],
  57: [10.0, 21.50, 21.09],
  58: [11.5, 22.50, 22.86],
  59: [12.5, 23.50, 24.60],
  60: [14.0, 24.50, 23.81],
  61: [15.0, 25.50, 26.40],
  62: [16.0, 26.50, 24.20],
  63: [17.0, 27.50, 23.95],
  64: [18.0, 28.50, 24.89],
  65: [19.5, 29.50, 24.05],
  66: [21.0, 30.50, 25.35],
  67: [22.0, 31.50, 26.65],
  68: [23.0, 32.50, 25.97],
  69: [24.5, 33.50, 28.04],
  70: [26.0, 34.75, 25.43],
  71: [27.0, 35.75, 25.44],
  72: [28.0, 36.75, 23.81],
  73: [28.5, 37.50, 25.59],
  74: [29.0, 38.50, 26.76],
  75: [30.0, 39.50, 25.92],
  76: [30.5, 40.50, 26.81],
  77: [31.0, 41.50, 29.68],
  78: [32.0, 42.50, 25.11],
  79: [33.0, 43.50, 28.53],
  80: [34.0, 44.50, 23.60],
  81: [35.0, 45.50, 25.15],
  82: [36.0, 46.50, 23.48],
  83: [37.0, 47.50, 25.28],
  84: [38.0, 48.50, 27.69]
};

const fallBack  = {
  55: [10.0, 12.0],
  56: [11.0, 12.0],
  57: [12.5, 12.5]
};
// const isValid = x => (typeof x !== 'undefined' && x !== null && !isNaN(x));

export const getLtvValue = ({ clientAge, isJoint, housePrice, ltvPlan }) => {
  const age = (clientAge > 84) ? 84 : clientAge;
  const tbl = (isJoint) ? tblJoint[age] : tblSingle[age];

  let fallback = null;

  if(age < 58)
  {
    fallback = fallBack[age]
  }

  let HealthyPreCalc = parseInt( housePrice * 0.01 * tbl[0], 10);
  let HealthPreCalcPer = tbl[0];

  if(HealthyPreCalc < 10000)
  {
    HealthyPreCalc = parseInt( housePrice * 0.01 * fallback[0], 10);
    HealthPreCalcPer = fallback[0];
  }

  if(HealthyPreCalc < 10000)
  {
    HealthyPreCalc = parseInt( housePrice * 0.01 * fallback[1], 10);
    HealthPreCalcPer = fallback[1];
  }

  const Healthy = HealthyPreCalc;
  const Mild = parseInt( housePrice * 0.01 * tbl[1], 10);
  const Moderate = parseInt( housePrice * 0.01 * tbl[1], 10);

  const result = { Healthy, Mild, Moderate };
  result.max = result[ ltvPlan || 'Moderate' ];
  result.diff = result.Moderate - result.Healthy;
  result.pct = { Healthy: HealthPreCalcPer, Mild: tbl[1], Moderate: tbl[1] };
  return result;
};



// WEBPACK FOOTER //
// ./src/services/LtvCalc.js